/* =========================================================
   Accordion RTE — inline image URL → <img> converter
   ========================================================= */
(function () {
  var imgUrlPattern = /https?:\/\/\S+\.(?:png|jpe?g|gif|webp|svg|avif|bmp|tiff?)(?:\?[^\s]*)?/gi;
  var imgUrlPatternFull = /^https?:\/\/\S+\.(?:png|jpe?g|gif|webp|svg|avif|bmp|tiff?)(?:\?[^\s]*)?$/i;

  function makeImg(src) {
    var img = document.createElement('img');
    img.src = src;
    img.alt = '';
    img.style.width = '79px';
    img.style.height = '14px';
    img.style.display = 'inline-block';
    img.style.verticalAlign = 'middle';
    return img;
  }

  function convertRteImageUrls(container) {
    Array.from(container.querySelectorAll('a')).forEach(function (a) {
      var href = (a.getAttribute('href') || '').trim();
      if (imgUrlPatternFull.test(href)) {
        a.parentNode.replaceChild(makeImg(href), a);
      }
    });

    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
    var textNodes = [];
    var node;
    while ((node = walker.nextNode())) textNodes.push(node);

    textNodes.forEach(function (textNode) {
      var text = textNode.nodeValue;
      imgUrlPattern.lastIndex = 0;
      if (!imgUrlPattern.test(text)) return;

      imgUrlPattern.lastIndex = 0;
      var fragment = document.createDocumentFragment();
      var lastIndex = 0;
      var match;

      while ((match = imgUrlPattern.exec(text)) !== null) {
        if (match.index > lastIndex) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        }
        fragment.appendChild(makeImg(match[0]));
        lastIndex = match.index + match[0].length;
      }

      if (lastIndex < text.length) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
      }

      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }

  window.__convertRteImageUrls = convertRteImageUrls;

  function init() {
    document.querySelectorAll('.accordion__content.rte').forEach(convertRteImageUrls);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =========================================================
   Accordion word popup — italic <em> click → modal
   ========================================================= */
(function () {
  if (window.__accordionWordPopupInit) return;
  window.__accordionWordPopupInit = true;

  var modal = document.getElementById('AccordionWordPopup');
  if (!modal) return;

  var modalBody = modal.querySelector('.accordion-word-popup__body');
  var modalHeader = modal.querySelector('.accordion-word-popup__header');
  var closeBtn = modal.querySelector('.accordion-word-popup__close');
  var overlay = modal.querySelector('.accordion-word-popup__overlay');

  function removeEmptyParagraphs(container) {
    container.querySelectorAll('p').forEach(function (p) {
      if (p.innerHTML.trim() === '&nbsp;' || p.textContent.trim() === '\u00a0' || p.textContent.trim() === '') {
        p.remove();
      }
    });
  }

  function openPopup(html, header, linkColor) {
    modalHeader.textContent = header || '';
    modalBody.innerHTML = html;
    removeEmptyParagraphs(modalBody);
    if (linkColor && linkColor !== 'rgba(0,0,0,0)') {
      modalBody.style.setProperty('--accordion-link-color', linkColor);
    } else {
      modalBody.style.removeProperty('--accordion-link-color');
    }
    if (window.__convertRteImageUrls) window.__convertRteImageUrls(modalBody);
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closePopup() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closePopup);
  modal.addEventListener('click', function (e) {
    if (!modal.querySelector('.accordion-word-popup__box').contains(e.target)) closePopup();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.style.display !== 'none') closePopup();
  });

  function processAccordion(dataEl) {
    var accordionId = dataEl.getAttribute('data-accordion-id');
    var accordionContent = document.getElementById(accordionId);
    if (!accordionContent) return;

    var linkColor = dataEl.getAttribute('data-link-color') || '';
    var entries = dataEl.querySelectorAll('.accordion-popup-entry');
    var triggers = accordionContent.querySelectorAll('em');

    triggers.forEach(function (trigger, index) {
      var entry = entries[index];
      if (!entry) return;

      var popupHtml = entry.innerHTML;
      var popupHeader = entry.getAttribute('data-header') || '';
      trigger.classList.add('accordion-popup-trigger');
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-haspopup', 'dialog');

      (function (html, header, color) {
        trigger.addEventListener('click', function (e) { e.preventDefault(); openPopup(html, header, color); });
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPopup(html, header, color); }
        });
      })(popupHtml, popupHeader, linkColor);
    });
  }

  function init() {
    document.querySelectorAll('.accordion-popup-data').forEach(processAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
